export default __webpack_public_path__ + "8f2652ff81e113f20c2f9a6e13b7bcbe.png";